<template>
    <div class="modelvcard">
        <div class="container">
            <h3 class="text-center ">les models Templates</h3>
            <section class="card d-flex flex-row flex-wrap">
            <div class="vcard__banner  w-90 position-relative " v-for="item in data" :key="item._id"  :value="item._id" :class="{ 'selected': item._id === selectedTemplateId }">
                     <button @click="showAlert(item._id)">  
                     <img :src="imgUrl + '/' + item.image" v-if="item.image !== ''" class="img-fluid banner-image"  />
                     </button>
                    <p class="text text-center"> {{ item.title }}</p>   
             </div>
             </section>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import APIs from './../../../../config'
    export default{
        data(){
            return{
                data:"",
                imgUrl: APIs.API_IMAGES,
                get_token: localStorage.getItem('admin_token'),
                user_id: localStorage.getItem('admin_id'),
                IdfromTemplate:"",
                selectedTemplateId: null // Nouvelle propriété pour suivre l'ID du modèle sélectionné
            }
        },
        props : {
            cardInfo : Object
        },
         async created(){
            await this.getTemplateCurrentData()
            await this.getSelectedTemplateId()
            console.log("created cardInfo id : ", this.cardInfo._id)
            console.log("created user_id :", this.user_id)
        },
        methods: {
            getTemplateCurrentData(){
        axios.get(`${APIs.API_URL}/card/admin/cardTemplate/${this.user_id}/${this.cardInfo._id}`,{                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${this.get_token}`
                    }
                }).then(res => {
                this.data = res.data
            })
            }, 
           async  getSelectedTemplateId() {
                try{
         const res =  await axios.get(`${APIs.API_URL}/card/admin/IDcardTemplate/${this.user_id}/${this.cardInfo._id}`,{                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${this.get_token}`
                    }
                })
                 this.selectedTemplateId = res.data.selectedTemplateId;
               
                }catch(err){
                     console.error('Erreur lors de la requête GET:', err);
                }

             },postIDTemplate(idtemplate){ 
                try{
        const d1 = {
            IdfromTemplate : idtemplate
        };

        axios.post(`${APIs.API_URL}/card/admin/IDcardTemplate/${this.user_id}/${this.cardInfo._id}`,d1,{                   
         headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${this.get_token}`,                     
                               }
                })
                }catch(err){
                    console.error('Erreur lors de la requête POST:', err);
                }
            },
            showAlert(idtemplate){
                this.$swal(
                   { title: "etes-vous sur de choisir cette template ?",
                    showDenyButton: false,
                    showCancelButton: true,
                    confirmButtonText: "oui",
                    icon:"question",
                    }
                    ).then((result) => {
                    if (result.isConfirmed) {
                        this.postIDTemplate(idtemplate);
                        this.selectedTemplateId = idtemplate; // Mettre à jour l'ID du modèle sélectionné
                       console.log('confirmed: '+idtemplate);
                    }else{
                        console.log("not confirmed")
                    } });
            },
           
        }
    }
</script>
<style scoped lang="scss">
       .modelvcard {
    background-color: white;
    padding: 2% 0;
    border-radius: 10px;
    margin: 0% 5%;
            h3{
            margin: 3% 0%;
        }

    .card {
        .vcard__banner {
            padding: 1%;
            border: 1px solid #00468B;
            border-radius: 10px;
            margin: 22px;
            flex: 0 0 27.33%;
            button{
                width:100%;
                border: none;
                padding: 0;
                border-top-left-radius: 10px;
                border-top-right-radius: 10px;
                height:300px;
                overflow: hidden; /*or scroll*/
                    img {
                border-top-left-radius: 10px;
                border-top-right-radius: 10px;
                width: 100%;
                height: auto;
                filter: grayscale(100%);
                transition: filter 0.1s ease;
                cursor: pointer;

                &:hover {
                    filter: grayscale(0%);
                }
               
            }
            }
            p {
                font-weight: bold;
                margin-top: 5%;
            }
            &.selected {
                    border : 1.5px solid #00224D;
                    box-shadow: 10px 10px 35px rgba(0, 0, 0, 0.5);
                    button{
                            img{
                                filter: grayscale(0%);
                            }
                    }
                    }
        }
    }
}

</style>